module.exports = __webpack_public_path__ + "static/media/Desktop 20-3-2566 22-20-47.7f7d2b9a.gif";